import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ChatService} from '@gallaghercp/core-chat';
import {AnalyticsService, APIInterceptor} from '@gallaghercp/core-frontend';
import {Subscription} from 'rxjs';

@Component({
  selector: 'core-block-chat',
  template: `
    <core-chat
      [showAIButton]="true"
      [submitButtonIconName]="'arrow_forward'"
      [hasAvatar]="false"
      [operatorDescription]="'AI BENEFITS ASSISTANT'"
      [botName]="botName"
      [startingMessage]="startingMessage | translate"
      [demoMode]="demoMode ?? false"
      [setDefaultDisplayMode]="'minimised'"
    ></core-chat>
  `,
  providers: [APIInterceptor],
  standalone: false,
})
export class BlockChatComponent implements OnInit, OnDestroy {
  @Input() botName!: string;
  @Input() startingMessage!: string;
  @Input() demoMode?: boolean;

  private eventSubscription!: Subscription;

  constructor(
    private readonly chat: ChatService,
    private readonly analytics: AnalyticsService,
  ) {
  }

  ngOnInit() {
    this.eventSubscription = this.chat.eventEmitter.subscribe((event: any): void => {
      const properties: any = {
        eventType: 'PageAction',
        category: event.category,
        label: event.label,
        value: event.value,
        message: event.message ?? event.response ?? undefined,
        bot: this.botName,
      };

      try {
        this.analytics.trackEvent(event.action, properties);
      } catch (e) {
        console.warn(e);
      }
    });
  }

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
  }
}
